export enum ModalTypes {
  DEFAULT = 'DEFAULT',
  DIALOG = 'DIALOG',
  FULLSCREEN = 'FULLSCREEN'
}

export enum ModalWarningTypes {
  NONE = 'none',
  WARNING = 'warning'
}